module.exports = __webpack_public_path__ + "img/benefit-card-3-desktop.7d66a585.png";